/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import './CSKH.scss';

const CSKH = ({ isOpen, onClose }) => {
  const BBOnlineService = () => {
    // Xử lý chức năng BBOnlineService tại đây
    console.log('BBOnlineService gọi');
  };

  const BBOnlineService2 = () => {
    // Xử lý chức năng BBOnlineService2 tại đây
    console.log('BBOnlineService2 gọi');
  };
  const closeModal = () => {
    onClose();
  };
  if (!isOpen) return null;
  return (
    <div id="service-modal-overlay" style={{ display: isOpen ? 'block' : 'none' }}>
      <div className="service-modal">
        <div className="modal-body">
          <img src="/logomobile.png" alt="" />
          <div className="cskh-box">
            <a href="https://t.me/qk88ad" className="cskh1"></a>
            <a href="https://t.me/qk88cskh" className="cskh2"></a>
          </div>
          
        </div>

        <span className="service-modal-close" onClick={closeModal}></span>
      </div>
    </div>
  );
};

export default CSKH;
